// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"36438f0f","310":"e184e6bd"}[chunkId] + ".chunk.js";
};